import React from "react";
import { Card, CardBody } from "reactstrap";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import { Link } from "react-router-dom";
import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CustomerCreditLogs = ({ creditLogs, loading }) => {
  console.log("🚀 ~ CustomerCreditLogs ~ creditLogs:", creditLogs);

  // const columns = [
  //   {
  //     name: "S.N",
  //     selector: (row, index) => index + 1,
  //     width: "75px",
  //   },
  //   {
  //     name: "Customer",
  //     cell: (row) => (
  //       <Link to={`/customer/${row.customerId}`}>
  //         {row.customerName}
  //       </Link>
  //     ),
  //     sortable: true,
  //   },
  //   {
  //     name: "Type",
  //     selector: (row) => row.type, // e.g. "Credit Added" / "Credit Used"
  //     sortable: true,
  //   },
  //   {
  //     name: "Amount",
  //     selector: (row) => row.amount,
  //     sortable: true,
  //     right: true,
  //   },
  //   {
  //     name: "Description",
  //     selector: (row) => row.description,
  //   },
  //   {
  //     name: "Date",
  //     selector: (row) => row.createdAt,
  //   },
  // ];

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "75px",
    },
    {
      name: "Order Ref",
      selector: (row) => row.orderRefrenceId,
      cell: (row) => {
        const ref = row.orderRefrenceId;

        return typeof ref === "string" &&
          ref.toLowerCase().startsWith("ord") ? (
          <Link to={`/order/${ref}`}>{ref}</Link>
        ) : (
          <span>{ref}</span>
        );
      },
      sortable: true,
      width: "190px",
    },
    {
      name: "Txn Date",
      selector: (row) => row.trxnDate_Nep,
      sortable: true,
    },
    {
      name: "Credit Amount",
      selector: (row) => row.creditAmount,
      cell: (row) => (
        <span>
          {" "}
          <NumberWithCommas number={row.creditAmount} />
        </span>
      ),
      sortable: true,
      right: true,
    },
    {
      name: "Paid Amount",
      selector: (row) => row.paidAmount,
      cell: (row) => (
        <span>
          {" "}
          <NumberWithCommas number={row.paidAmount} />
        </span>
      ),
      sortable: true,
      right: true,
    },
    {
      name: "Remaining Amount",
      selector: (row) => row.remainingAmount,
      cell: (row) => (
        <span>
          {" "}
          <NumberWithCommas number={row.remainingAmount} />
        </span>
      ),
      sortable: true,
      right: true,
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks,
    },
    {
      name: "Created At",
      selector: (row) => row.createdDate?.split("T")[0], // format to YYYY-MM-DD
      sortable: true,
    },
    {
      name: "Created By",
      selector: (row) => row.createdBy,
      width: "210px",
    },
  ];

  return (
    <div>
      <Card className="d-none d-lg-block">
        <CustomDataTable
          responsive
          striped
          pagination
          fixedHeader
          persistTableHead
          progressPending={loading}
          customStyles={customStyles}
          progressComponent={
            <div className="my-3 text-center">
              <Triangle
                visible={true}
                height="80"
                width="80"
                color="#5B71B9"
                ariaLabel="triangle-loading"
              />
              <h5 className="mt-1">Loading...</h5>
            </div>
          }
          columns={columns}
          data={creditLogs}
        />
      </Card>
    </div>
  );
};

export default CustomerCreditLogs;
